/**
 * API 工具函数
 * 处理数据格式转换、命名转换等
 */

/**
 * 将 snake_case 转换为 camelCase
 */
export function toCamelCase(str: string): string {
  return str.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
}

/**
 * 将 camelCase 转换为 snake_case
 */
export function toSnakeCase(str: string): string {
  return str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
}

/**
 * 递归转换对象的键名为 camelCase
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function keysToCamelCase<T = any>(obj: any): T {
  if (obj === null || obj === undefined) return obj;

  if (Array.isArray(obj)) {
    return obj.map(keysToCamelCase) as T;
  }

  if (typeof obj === 'object' && obj.constructor === Object) {
    return Object.keys(obj).reduce((acc, key) => {
      const camelKey = toCamelCase(key);
      acc[camelKey] = keysToCamelCase(obj[key]);
      return acc;
    }, {} as any) as T;
  }

  return obj;
}

/**
 * 递归转换对象的键名为 snake_case
 * 同时过滤掉 undefined 值
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function keysToSnakeCase<T = any>(obj: any): T {
  if (obj === null || obj === undefined) return obj;

  if (Array.isArray(obj)) {
    return obj.map(keysToSnakeCase) as T;
  }

  if (typeof obj === 'object' && obj.constructor === Object) {
    return Object.keys(obj).reduce((acc, key) => {
      const value = obj[key];
      // 过滤掉 undefined 值
      if (value !== undefined) {
        const snakeKey = toSnakeCase(key);
        acc[snakeKey] = keysToSnakeCase(value);
      }
      return acc;
    }, {} as any) as T;
  }

  return obj;
}
